<h2 mat-dialog-title style="text-align: center">AGB unterzeichnen</h2>
<mat-dialog-content #cnt class="mat-typography" style="max-height: 85%">
  <div
    style="position: relative; top: 0; left: 0; padding-bottom: 1rem"
    id="agb_content"
  >
    <div *ngIf="isLoading" class="document-progress-bar-placeholder"></div>
    <div *ngIf="isLoading" class="document-progress-bar-wrapper">
      <app-document-progress-bar></app-document-progress-bar>
    </div>
    <ng-container *ngIf="!isLoading">
      <div id="agb_top"></div>
      <img *ngIf="!imgUrl" #docImg class="img-pdf-content" />
      <img *ngIf="imgUrl" [src]="imgUrl" class="img-pdf-content" />

      <div
        class="pos-absolute bg-transparent"
        [style]="signatureStyle"
        id="area"
      >
        <canvas
          #signCanvas
          class="sign-canvas-style"
          [style]="signatureCanvasStyle"
        ></canvas>
        <div class="row-layout flex-content-end" style="margin-top: 0.9cm">
          <button (click)="clear()">Leeren</button>
        </div>
        <div></div>
      </div>
    </ng-container>
  </div>
</mat-dialog-content>
<div
  mat-dialog-actions
  class="row-layout flex-content-space-between pdf-dialog-actions"
  style="margin-top: 10px"
>
  <div>
    <button mat-button class="document-cancel" (click)="scrollTop(true)">
      Nach oben
    </button>
    <button mat-button class="document-cancel" (click)="scrollTop(false)">
      Nach unten
    </button>
  </div>
  <div>
    <button mat-button class="document-cancel" (click)="signClose(false)">
      Abbrechen
    </button>
    <button mat-button class="document-save" (click)="signClose(true)">
      Speichern
    </button>
  </div>
</div>
